function HospitalDetailController($scope, hospital) {
  $scope.hospital = hospital;
}

HospitalDetailController.$inject = ['$scope', 'hospital'];

export default HospitalDetailController;



/** WEBPACK FOOTER **
 ** ./src/app/hospitals/hospital-detail.controller.js
 **/